import configureStore from 'app/redux/store';

const ClientStore = configureStore();
export default ClientStore;

